// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__-jjrr"};